import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,isFunction } from '../../../../utils/utils';
import { SteeringWheel } from '../../../../components/icons';
import JourneyDriverSelect from '../../../components/Driver/JourneyDriverSelect';
import { connect } from 'react-redux';
import { updateJourney } from '../../../../store/actions/tripActionCreator';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 84,
    padding: "16px 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    justifyContent:'space-between',
    cursor:'pointer'
  },
  icon:{
    fontSize:52,
    color:'rgba(0, 51, 204, 0.25)'
  },
  iconDirection:{
    fontSize:24,
    color:'#03c',
    fontWeight:600
  },
  info:{
    display:'flex',
    alignItems:'center'
  },
  driverLabel:{
    fontSize:18,
    color:'#0033cc',
    fontWeight:600
  },
  driverInfo:{
    marginLeft:24
  }
}));
const JourneyAssignDriverCard = (props) => {
  const {driver,journey,fetchJourney,dispatchUpdateTrip} = props;
  const classes = useStyles();
  let history = useHistory();
  const [driverNameModalOpen, setDriverNameModalOpen] = React.useState(false);
  const handleDriverSelectOpen = () => {
    setDriverNameModalOpen(true);
  };
  const handleDriverSelectClose = () => {
    setDriverNameModalOpen(false);
    if (isFunction(fetchJourney) && journey.id) {
      fetchJourney(journey.id)
    }
  };
  const handleDriverSelectConfirm = (response) => {
    if (response && response.id) {
    dispatchUpdateTrip(journey.id, { driverId: response.id }, (data) => {
         if (data && data.status && data.status.code && data.status.code === 200) {
           setDriverNameModalOpen(false);
              if (isFunction(fetchJourney) && journey.id) {
                fetchJourney(journey.id)
              }
         }
       }, () => {

       })
     }
  }
  const goToDriverView = () => {
    if (driver && driver.driverId && !driver.isDriverDeleted) {
      const driverId = driver.driverId;
      const driverName = driver.driverName;
      const status = driver.status ? driver.status : '';
      history.push({
        pathname: `/drivers/single-driver/${driverId}`,
        state: {
          id: 8,
          driverStatus: status || null,
          pageTitle: driverName ? driverName : 'Driver View',
          driverId: driverId
        }
      });
    }
  }
  return (
    <>
      <Paper component='div' className={classes.card} onClick={handleDriverSelectOpen}>
        <div className={classes.info}>
          <SteeringWheel className={classes.icon} />
          <div className={classes.driverInfo}>
            <Typography className={classes.driverLabel}>Assign Driver for Trip</Typography>
          </div>      
        </div>
        <ChevronRightIcon className={classes.iconDirection} />
      </Paper>
      {driverNameModalOpen && <JourneyDriverSelect selectedDriver={null} journey={journey} updateJourney={updateJourney} onOpen={driverNameModalOpen} onClose={handleDriverSelectClose} onConfirm={handleDriverSelectConfirm} />}
    </>
  );
}
const JourneyAssignDriverCardWithRouter = withRouter(JourneyAssignDriverCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateJourney(tripId, trip, onSuccess, onError));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyAssignDriverCardWithRouter);